import { axiosClient } from "@/api/axios";

export function getAll() {
  return axiosClient.get(`course-areas`);
}
